<template>
    <section class="py-20">
        <div class="container mx-auto px-4">
            <div class="text-center mb-16">
                <h2 class="section-title text-slate-700 dark:text-slate-300">Skills</h2>
                <p class="section-subtitle text-slate-700 dark:text-slate-400">Languages and Tools</p>
                <img src="https://camo.githubusercontent.com/9a9ba649a6596fb654f436a34eb113d58024e44337e36b601f9f0848bd36afad/68747470733a2f2f736b696c6c69636f6e732e6465762f69636f6e733f693d6a732c68746d6c2c6373732c7068702c6c61726176656c2c6e6f64656a732c616c70696e656a732c7461696c77696e642c7675652c73757061626173652c646f636b65722c64656269616e"
                    alt="Profile Image" class="mx-auto">
            </div>
            <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div v-for="skill in skills" :key="skill.name" class="text-center">
                    <div class="bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl p-6 mb-4">
                        <i :class="skill.icon" class="text-4xl text-primary-600"></i>
                    </div>
                    <h3 class="font-bold mb-2">{{ skill.name }}</h3>
                    <div class="w-full bg-secondary-200 rounded-full h-2">
                        <div class="bg-primary-600 h-2 rounded-full" :style="{ width: skill.level + '%' }"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            skills: [
                { name: 'Vue.js', icon: 'fab fa-vuejs', level: 80 },
                { name: 'Laravel', icon: 'fab fa-laravel', level: 95 },
                { name: 'Node.js', icon: 'fab fa-node-js', level: 90 },
                { name: 'Ubuntu', icon: 'fab fa-ubuntu', level: 90 },
                { name: 'JavaScript', icon: 'fab fa-js-square', level: 95 },
                { name: 'CSS/SCSS', icon: 'fab fa-css3-alt', level: 95 },
                { name: 'Git', icon: 'fab fa-git-alt', level: 95 },
                { name: 'Docker', icon: 'fab fa-docker', level: 80 }
            ]
        }
    }
}
</script>